/* tslint:disable */
/* eslint-disable */
/**
 * Ingestion Tool UI
 * Ingestion Tool UI None
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface App
 */
export interface App {
    /**
     * 
     * @type {boolean}
     * @memberof App
     */
    'enableHdForSd'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof App
     */
    'version'?: string | null;
}
/**
 * 
 * @export
 * @interface Aspera
 */
export interface Aspera {
    /**
     * 
     * @type {Node}
     * @memberof Aspera
     */
    'node'?: Node;
}
/**
 * 
 * @export
 * @interface AudioInfo
 */
export interface AudioInfo {
    /**
     * 
     * @type {number}
     * @memberof AudioInfo
     */
    'bit_depth'?: number;
    /**
     * 
     * @type {number}
     * @memberof AudioInfo
     */
    'channels'?: number;
    /**
     * 
     * @type {number}
     * @memberof AudioInfo
     */
    'duration'?: number;
    /**
     * 
     * @type {number}
     * @memberof AudioInfo
     */
    'sample_rate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AudioInfo
     */
    'isDolby'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AudioInfo
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface CprsManufacturer
 */
export interface CprsManufacturer {
    /**
     * 
     * @type {number}
     * @memberof CprsManufacturer
     */
    'manufacturerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CprsManufacturer
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CprsRelease
 */
export interface CprsRelease {
    /**
     * 
     * @type {string}
     * @memberof CprsRelease
     */
    'upc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CprsRelease
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CprsRelease
     */
    'artist'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CprsRelease
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CprsRelease
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CprsRelease
     */
    'packageUpc'?: string | null;
    /**
     * 
     * @type {Array<CprsManufacturer>}
     * @memberof CprsRelease
     */
    'manufacturers'?: Array<CprsManufacturer> | null;
}
/**
 * 
 * @export
 * @interface DdpPqDescriptorPacket
 */
export interface DdpPqDescriptorPacket {
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'subcodePacketValid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'aTimeMinutes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'aTimeSeconds'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'aTimeFrame'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'controlByte1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'isrc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'upc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'text'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DdpPqDescriptorPacket
     */
    'trackNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof DdpPqDescriptorPacket
     */
    'indexNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'duration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DdpPqDescriptorPacket
     */
    'durationMs'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DdpPqDescriptorPacket
     */
    'sizeBytes'?: number;
}
/**
 * 
 * @export
 * @interface DdpTrackTitle
 */
export interface DdpTrackTitle {
    /**
     * 
     * @type {number}
     * @memberof DdpTrackTitle
     */
    'trackNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof DdpTrackTitle
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface Node
 */
export interface Node {
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    'accessKey'?: string | null;
}
/**
 * 
 * @export
 * @interface Path
 */
export interface Path {
    /**
     * 
     * @type {string}
     * @memberof Path
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Path
     */
    'destination'?: string | null;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'startIngestion'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'ingestHasStarted'?: boolean;
    /**
     * 
     * @type {Array<Resource>}
     * @memberof Project
     */
    'resources'?: Array<Resource> | null;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'jobId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'jobStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'upc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'isIngestRequestedAfterUpload'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'creatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'lastModified'?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'created'?: string;
    /**
     * 
     * @type {Array<TrackResource>}
     * @memberof Project
     */
    'trackResourceMap'?: Array<TrackResource> | null;
    /**
     * 
     * @type {ReleaseInfoDto}
     * @memberof Project
     */
    'releaseInfo'?: ReleaseInfoDto;
    /**
     * 
     * @type {ResourceInfoDto}
     * @memberof Project
     */
    'resourceInfo'?: ResourceInfoDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof Project
     */
    'overrideRestrictions'?: Array<string> | null;
    /**
     * 
     * @type {Array<CprsRelease>}
     * @memberof Project
     */
    'cprsInformation'?: Array<CprsRelease> | null;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'version'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'filesDeletedFromS3'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'filesDeletedFromS3Date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'resourcePathKey'?: string;
    /**
     * 
     * @type {ProjectType}
     * @memberof Project
     */
    'projectType'?: ProjectType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectType = {
    Unknown: 'Unknown',
    Resource: 'Resource',
    Release: 'Release'
} as const;

export type ProjectType = typeof ProjectType[keyof typeof ProjectType];


/**
 * 
 * @export
 * @interface ReleaseInfoDto
 */
export interface ReleaseInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'upc': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'artists': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'embargoLiftDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'configuration': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'parentalAdvisory': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'resolutionType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'labelOwner': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'countryOwner': string;
    /**
     * 
     * @type {Array<TrackGroup>}
     * @memberof ReleaseInfoDto
     */
    'trackGroups': Array<TrackGroup>;
    /**
     * 
     * @type {string}
     * @memberof ReleaseInfoDto
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof ReleaseInfoDto
     */
    'embargoed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReleaseInfoDto
     */
    'physicalScope'?: boolean;
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'md5'?: string | null;
    /**
     * 
     * @type {ResourceType}
     * @memberof Resource
     */
    'resourceType'?: ResourceType;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'filename'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    's3Path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'localPath'?: string | null;
    /**
     * 
     * @type {UploadStatus}
     * @memberof Resource
     */
    'uploadStatus'?: UploadStatus;
    /**
     * 
     * @type {AudioInfo}
     * @memberof Resource
     */
    'audioInfo'?: AudioInfo;
    /**
     * 
     * @type {UploadError}
     * @memberof Resource
     */
    'uploadError'?: UploadError;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    'uploadPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    'fileSize'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'relativePath'?: string | null;
    /**
     * 
     * @type {Array<DdpPqDescriptorPacket>}
     * @memberof Resource
     */
    'pqDescriptorPackets'?: Array<DdpPqDescriptorPacket> | null;
    /**
     * 
     * @type {Array<DdpTrackTitle>}
     * @memberof Resource
     */
    'trackTitles'?: Array<DdpTrackTitle> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'projectId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'cdTextString'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'pqPacketString'?: string | null;
}


/**
 * 
 * @export
 * @interface ResourceInfoDto
 */
export interface ResourceInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'isrc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'artists'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'approvalStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'deliveryStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'resourceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'parentalAdvisory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'channelConfig'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'labelOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceInfoDto
     */
    'countryOwner'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResourceInfoDto
     */
    'duration'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ResourceType = {
    Unknown: 'Unknown',
    Audio: 'Audio',
    File: 'File',
    DdpId: 'DdpId',
    DdpMs: 'DdpMs',
    DdpPq: 'DdpPq',
    DdpText: 'DdpText',
    CmfBd25: 'CmfBd25',
    CmfBd50: 'CmfBd50'
} as const;

export type ResourceType = typeof ResourceType[keyof typeof ResourceType];


/**
 * 
 * @export
 * @interface ResourceUploadState
 */
export interface ResourceUploadState {
    /**
     * 
     * @type {string}
     * @memberof ResourceUploadState
     */
    'localPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceUploadState
     */
    's3Path'?: string | null;
    /**
     * 
     * @type {UploadStatus}
     * @memberof ResourceUploadState
     */
    'uploadStatus'?: UploadStatus;
    /**
     * 
     * @type {number}
     * @memberof ResourceUploadState
     */
    'uploadPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResourceUploadState
     */
    'errorCode'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceUploadState
     */
    'errorDescription'?: string | null;
}


/**
 * 
 * @export
 * @interface Tags
 */
export interface Tags {
    /**
     * 
     * @type {Aspera}
     * @memberof Tags
     */
    'aspera'?: Aspera;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Tags
     */
    'ingestionTool'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface Track
 */
export interface Track {
    /**
     * 
     * @type {number}
     * @memberof Track
     */
    'groupNumber': number;
    /**
     * 
     * @type {number}
     * @memberof Track
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof Track
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Track
     */
    'isrc': string;
    /**
     * 
     * @type {number}
     * @memberof Track
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof Track
     */
    'versionTitle'?: string | null;
}
/**
 * 
 * @export
 * @interface TrackGroup
 */
export interface TrackGroup {
    /**
     * 
     * @type {number}
     * @memberof TrackGroup
     */
    'groupNumber': number;
    /**
     * 
     * @type {Array<Track>}
     * @memberof TrackGroup
     */
    'tracks': Array<Track>;
    /**
     * 
     * @type {number}
     * @memberof TrackGroup
     */
    'duration': number;
}
/**
 * 
 * @export
 * @interface TrackResource
 */
export interface TrackResource {
    /**
     * 
     * @type {string}
     * @memberof TrackResource
     */
    'resourceId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackResource
     */
    'trackId'?: number;
}
/**
 * 
 * @export
 * @interface TransferSpec
 */
export interface TransferSpec {
    /**
     * 
     * @type {Array<Path>}
     * @memberof TransferSpec
     */
    'paths'?: Array<Path> | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'sourceRoot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'destinationRoot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'direction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransferSpec
     */
    'targetRateCapKbps'?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'cipher'?: string | null;
    /**
     * 
     * @type {Tags}
     * @memberof TransferSpec
     */
    'tags'?: Tags;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'ratePolicyAllowed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'ratePolicy'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransferSpec
     */
    'targetRateKbps'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransferSpec
     */
    'minRateCapKbps'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransferSpec
     */
    'minRateKbps'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferSpec
     */
    'lockMinRate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferSpec
     */
    'createDir'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'remoteHost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'remoteUser'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof TransferSpec
     */
    'sshfp'?: any | null;
    /**
     * 
     * @type {number}
     * @memberof TransferSpec
     */
    'sshPort'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransferSpec
     */
    'faspPort'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferSpec
     */
    'httpFallback'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'authentication'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TransferSpec
     */
    'auth'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'cookie'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TransferSpec
     */
    'allowDialogs'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    's3Path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'resume'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferSpec
     */
    'overwritePolicy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TransferSpec
     */
    'isAutoUpload'?: boolean;
}
/**
 * 
 * @export
 * @interface UploadError
 */
export interface UploadError {
    /**
     * 
     * @type {number}
     * @memberof UploadError
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadError
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UploadStatus = {
    Unknown: 'Unknown',
    Requested: 'Requested',
    InProgress: 'InProgress',
    Complete: 'Complete',
    Failed: 'Failed'
} as const;

export type UploadStatus = typeof UploadStatus[keyof typeof UploadStatus];


/**
 * 
 * @export
 * @interface Workspace
 */
export interface Workspace {
    /**
     * 
     * @type {Array<Project>}
     * @memberof Workspace
     */
    'projects'?: Array<Project> | null;
}

/**
 * AppApi - axios parameter creator
 * @export
 */
export const AppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/App`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppApi - functional programming interface
 * @export
 */
export const AppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<App>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppApi.appGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppApi - factory interface
 * @export
 */
export const AppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appGet(options?: AxiosRequestConfig): AxiosPromise<App> {
            return localVarFp.appGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
export class AppApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appGet(options?: AxiosRequestConfig) {
        return AppApiFp(this.configuration).appGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AsperaUploadApi - axios parameter creator
 * @export
 */
export const AsperaUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [projectId] 
         * @param {Array<Resource>} [resource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asperaUploadSpecPost: async (projectId?: string, resource?: Array<Resource>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Aspera/UploadSpec`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AsperaUploadApi - functional programming interface
 * @export
 */
export const AsperaUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AsperaUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [projectId] 
         * @param {Array<Resource>} [resource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asperaUploadSpecPost(projectId?: string, resource?: Array<Resource>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asperaUploadSpecPost(projectId, resource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AsperaUploadApi.asperaUploadSpecPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AsperaUploadApi - factory interface
 * @export
 */
export const AsperaUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AsperaUploadApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [projectId] 
         * @param {Array<Resource>} [resource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asperaUploadSpecPost(projectId?: string, resource?: Array<Resource>, options?: AxiosRequestConfig): AxiosPromise<TransferSpec> {
            return localVarFp.asperaUploadSpecPost(projectId, resource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AsperaUploadApi - object-oriented interface
 * @export
 * @class AsperaUploadApi
 * @extends {BaseAPI}
 */
export class AsperaUploadApi extends BaseAPI {
    /**
     * 
     * @param {string} [projectId] 
     * @param {Array<Resource>} [resource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsperaUploadApi
     */
    public asperaUploadSpecPost(projectId?: string, resource?: Array<Resource>, options?: AxiosRequestConfig) {
        return AsperaUploadApiFp(this.configuration).asperaUploadSpecPost(projectId, resource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('_delete', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<Resource>} [resource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addResources: async (projectId: string, resource?: Array<Resource>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addResources', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}/resources`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearMappedResources: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('clearMappedResources', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}/track-Map`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBatch: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/BatchDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResources: async (projectId: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteResources', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}/resources`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateProject: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('duplicateProject', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}/duplicate`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProject', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {number} trackId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapResource: async (projectId: string, trackId: number, resourceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('mapResource', 'projectId', projectId)
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('mapResource', 'trackId', trackId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('mapResource', 'resourceId', resourceId)
            const localVarPath = `/Projects/{projectId}/track-map/tracks/{trackId}/resources/{resourceId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"trackId"}}`, encodeURIComponent(String(trackId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<TrackResource>} [trackResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTrackResources: async (projectId: string, trackResource?: Array<TrackResource>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('mapTrackResources', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}/track-map/trackResources`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {boolean} isRequested 
         * @param {string} [jobId] 
         * @param {string} [jobStartTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIsIngestRequestedAfterUpload: async (projectId: string, isRequested: boolean, jobId?: string, jobStartTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('setIsIngestRequestedAfterUpload', 'projectId', projectId)
            // verify required parameter 'isRequested' is not null or undefined
            assertParamExists('setIsIngestRequestedAfterUpload', 'isRequested', isRequested)
            const localVarPath = `/Projects/{projectId}/IsIngestRequestedAfterUpload/{isRequested}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"isRequested"}}`, encodeURIComponent(String(isRequested)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }

            if (jobStartTime !== undefined) {
                localVarQueryParameter['jobStartTime'] = (jobStartTime as any instanceof Date) ?
                    (jobStartTime as any).toISOString() :
                    jobStartTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} jobId 
         * @param {boolean} isIngest 
         * @param {string} [jobStartTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJobId: async (projectId: string, jobId: string, isIngest: boolean, jobStartTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('setJobId', 'projectId', projectId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('setJobId', 'jobId', jobId)
            // verify required parameter 'isIngest' is not null or undefined
            assertParamExists('setJobId', 'isIngest', isIngest)
            const localVarPath = `/Projects/{projectId}/job/{jobId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (isIngest !== undefined) {
                localVarQueryParameter['isIngest'] = isIngest;
            }

            if (jobStartTime !== undefined) {
                localVarQueryParameter['jobStartTime'] = (jobStartTime as any instanceof Date) ?
                    (jobStartTime as any).toISOString() :
                    jobStartTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} identifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProjectIdentifier: async (projectId: string, identifier: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('setProjectIdentifier', 'projectId', projectId)
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('setProjectIdentifier', 'identifier', identifier)
            const localVarPath = `/Projects/{projectId}/product/{identifier}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProjectNotes: async (projectId: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('setProjectNotes', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}/notes`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {boolean} overrideRestrictions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProjectOverrideRestrictions: async (projectId: string, overrideRestrictions: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('setProjectOverrideRestrictions', 'projectId', projectId)
            // verify required parameter 'overrideRestrictions' is not null or undefined
            assertParamExists('setProjectOverrideRestrictions', 'overrideRestrictions', overrideRestrictions)
            const localVarPath = `/Projects/{projectId}/overrideRestrictions/{overrideRestrictions}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"overrideRestrictions"}}`, encodeURIComponent(String(overrideRestrictions)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmapResource: async (projectId: string, resourceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('unmapResource', 'projectId', projectId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('unmapResource', 'resourceId', resourceId)
            const localVarPath = `/Projects/{projectId}/track-map/resources/{resourceId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<ResourceUploadState>} [resourceUploadState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUploadStates: async (projectId: string, resourceUploadState?: Array<ResourceUploadState>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateUploadStates', 'projectId', projectId)
            const localVarPath = `/Projects/{projectId}/resources`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourceUploadState, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<Resource>} [resource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addResources(projectId: string, resource?: Array<Resource>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addResources(projectId, resource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.addResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearMappedResources(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearMappedResources(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.clearMappedResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.createProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBatch(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Project>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBatch(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.deleteBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResources(projectId: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteResources(projectId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.deleteResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateProject(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.duplicateProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProject(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjects(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Project>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {number} trackId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapResource(projectId: string, trackId: number, resourceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapResource(projectId, trackId, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.mapResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<TrackResource>} [trackResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapTrackResources(projectId: string, trackResource?: Array<TrackResource>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapTrackResources(projectId, trackResource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.mapTrackResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {boolean} isRequested 
         * @param {string} [jobId] 
         * @param {string} [jobStartTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIsIngestRequestedAfterUpload(projectId: string, isRequested: boolean, jobId?: string, jobStartTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIsIngestRequestedAfterUpload(projectId, isRequested, jobId, jobStartTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.setIsIngestRequestedAfterUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} jobId 
         * @param {boolean} isIngest 
         * @param {string} [jobStartTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setJobId(projectId: string, jobId: string, isIngest: boolean, jobStartTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setJobId(projectId, jobId, isIngest, jobStartTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.setJobId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} identifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProjectIdentifier(projectId: string, identifier: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProjectIdentifier(projectId, identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.setProjectIdentifier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProjectNotes(projectId: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProjectNotes(projectId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.setProjectNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {boolean} overrideRestrictions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProjectOverrideRestrictions(projectId: string, overrideRestrictions: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProjectOverrideRestrictions(projectId, overrideRestrictions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.setProjectOverrideRestrictions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmapResource(projectId: string, resourceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmapResource(projectId, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.unmapResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<ResourceUploadState>} [resourceUploadState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUploadStates(projectId: string, resourceUploadState?: Array<ResourceUploadState>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUploadStates(projectId, resourceUploadState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.updateUploadStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(projectId: string, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<Resource>} [resource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addResources(projectId: string, resource?: Array<Resource>, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.addResources(projectId, resource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearMappedResources(projectId: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.clearMappedResources(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.createProject(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBatch(requestBody?: Array<string>, options?: AxiosRequestConfig): AxiosPromise<Array<Project>> {
            return localVarFp.deleteBatch(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResources(projectId: string, requestBody?: Array<string>, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.deleteResources(projectId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateProject(projectId: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.duplicateProject(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(projectId: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.getProject(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(options?: AxiosRequestConfig): AxiosPromise<Array<Project>> {
            return localVarFp.getProjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {number} trackId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapResource(projectId: string, trackId: number, resourceId: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.mapResource(projectId, trackId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<TrackResource>} [trackResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTrackResources(projectId: string, trackResource?: Array<TrackResource>, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.mapTrackResources(projectId, trackResource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {boolean} isRequested 
         * @param {string} [jobId] 
         * @param {string} [jobStartTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIsIngestRequestedAfterUpload(projectId: string, isRequested: boolean, jobId?: string, jobStartTime?: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.setIsIngestRequestedAfterUpload(projectId, isRequested, jobId, jobStartTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} jobId 
         * @param {boolean} isIngest 
         * @param {string} [jobStartTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJobId(projectId: string, jobId: string, isIngest: boolean, jobStartTime?: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.setJobId(projectId, jobId, isIngest, jobStartTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} identifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProjectIdentifier(projectId: string, identifier: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.setProjectIdentifier(projectId, identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProjectNotes(projectId: string, body?: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.setProjectNotes(projectId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {boolean} overrideRestrictions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProjectOverrideRestrictions(projectId: string, overrideRestrictions: boolean, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.setProjectOverrideRestrictions(projectId, overrideRestrictions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmapResource(projectId: string, resourceId: string, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.unmapResource(projectId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {Array<ResourceUploadState>} [resourceUploadState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUploadStates(projectId: string, resourceUploadState?: Array<ResourceUploadState>, options?: AxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.updateUploadStates(projectId, resourceUploadState, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public _delete(projectId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration)._delete(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {Array<Resource>} [resource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public addResources(projectId: string, resource?: Array<Resource>, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).addResources(projectId, resource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public clearMappedResources(projectId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).clearMappedResources(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public createProject(options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createProject(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public deleteBatch(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).deleteBatch(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public deleteResources(projectId: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).deleteResources(projectId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public duplicateProject(projectId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).duplicateProject(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProject(projectId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProject(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjects(options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {number} trackId 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public mapResource(projectId: string, trackId: number, resourceId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).mapResource(projectId, trackId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {Array<TrackResource>} [trackResource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public mapTrackResources(projectId: string, trackResource?: Array<TrackResource>, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).mapTrackResources(projectId, trackResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {boolean} isRequested 
     * @param {string} [jobId] 
     * @param {string} [jobStartTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public setIsIngestRequestedAfterUpload(projectId: string, isRequested: boolean, jobId?: string, jobStartTime?: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).setIsIngestRequestedAfterUpload(projectId, isRequested, jobId, jobStartTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {string} jobId 
     * @param {boolean} isIngest 
     * @param {string} [jobStartTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public setJobId(projectId: string, jobId: string, isIngest: boolean, jobStartTime?: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).setJobId(projectId, jobId, isIngest, jobStartTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {string} identifier 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public setProjectIdentifier(projectId: string, identifier: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).setProjectIdentifier(projectId, identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public setProjectNotes(projectId: string, body?: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).setProjectNotes(projectId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {boolean} overrideRestrictions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public setProjectOverrideRestrictions(projectId: string, overrideRestrictions: boolean, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).setProjectOverrideRestrictions(projectId, overrideRestrictions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public unmapResource(projectId: string, resourceId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).unmapResource(projectId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {Array<ResourceUploadState>} [resourceUploadState] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public updateUploadStates(projectId: string, resourceUploadState?: Array<ResourceUploadState>, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).updateUploadStates(projectId, resourceUploadState, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkspaceApi - axios parameter creator
 * @export
 */
export const WorkspaceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkspaceApi - functional programming interface
 * @export
 */
export const WorkspaceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkspaceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Workspace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspaceApi.workspaceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkspaceApi - factory interface
 * @export
 */
export const WorkspaceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkspaceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceGet(options?: AxiosRequestConfig): AxiosPromise<Workspace> {
            return localVarFp.workspaceGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkspaceApi - object-oriented interface
 * @export
 * @class WorkspaceApi
 * @extends {BaseAPI}
 */
export class WorkspaceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceApi
     */
    public workspaceGet(options?: AxiosRequestConfig) {
        return WorkspaceApiFp(this.configuration).workspaceGet(options).then((request) => request(this.axios, this.basePath));
    }
}



